import i18n from 'i18next';

export const columns = [
  {
    id: 'work_order_id',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.workOrderId'),
  },
  {
    id: 'companyName',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.company'),
  },
  {
    id: 'unitId',
    numeric: false,
    disablePadding: false,
    needSorting: false,
    label: i18n.t('vehicles.vin'),
  },
  {
    id: 'reported_date',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.reportedDate'),
  },
  {
    id: 'workOrderType',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('workOrders.serviceType'),
  },
  {
    id: 'report',
    numeric: false,
    needSorting: false,
    disablePadding: false,
    label: '',
  },
];

export const formattedType = {
  TRACTOR_DAY_CAB: 'Tractor Day Cab',
  TRACTOR_SLEEPER: 'Tractor Sleeper',
  BOBTAIL: 'Bobtail',
  STRAIGHT_TRUCK: 'Straight Truck',
  BOX_TRUCK: 'Box Truck',
  PICKUP: 'Pickup',
  PRIVATE_PASSENGER: 'Private Passenger',
  VACUUM: 'Vacuum',
  VAN: 'Van',
  OTHER: 'Other',
};

export const sortColumnMapping = {
  unitId: 'vehicleName',
  work_order_id: 'idPub',
  type: 'unitType',
  reported_date: 'createDate',
  scheduled_date: 'beginDate',
  due_date: 'endDate',
  workOrderType: 'type',
  status: 'state',
};

export const downloadTypes = [
  { label: 'DVIR', value: 'DVIR' },
  { label: 'POST-TRIP', value: 'POST_TRIP' },
  { label: 'PRE-TRIP', value: 'PRE_TRIP' },
];
